import type { GeometryPayload } from '@/components/whiteboard-v2/types';

/**
 * Convert natural-language geometry description into structured payload.
 */
export async function generateGeometryPayload(
  description: string,
  context?: string,
): Promise<GeometryPayload> {
  const response = await fetch('/napi/diagram/geometry/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ description, context }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error || `Geometry API returned ${response.status}`);
  }

  const data = (await response.json()) as { payload: GeometryPayload };
  return data.payload;
}
